export const DISPATCH_SUBSCRIBER_EXPORTS_LIST_PATH = "/dispatch-subscriber-exports";
export const CREATE_DISPATCH_SUBSCRIBER_EXPORT_PATH =
  "/dispatch-subscriber-exports/create";
